export default function ArrowRightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="19"
      fill="none"
      viewBox="0 0 11 19"
    >
      <path
        fill="#3E464F"
        d="M9.664 8.836c.352.39.352.976 0 1.328l-7.5 7.5c-.39.39-.977.39-1.328 0a.856.856 0 0 1 0-1.289l6.836-6.836L.836 2.664a.855.855 0 0 1 0-1.289.855.855 0 0 1 1.289 0l7.54 7.46Z"
      />
    </svg>
  )
}
